import { ToggleGroup, ToggleGroupItem } from "../../ui/toggle-group";
import {
  TICKET_SIZE_OPTIONS,
  useTicketSize,
  type TicketSize,
} from "../../pages/AthenaPricingEngine/lib/ticket-size";

/**
 * Micro / Small / Mid-market / Large. Clicking the selected band again clears it (every ticket size).
 * `disabled` is for pages whose data has no deal-size dimension: the control stays put so it is always in
 * the same place, but shows no selection and does nothing.
 */
export function TicketSizeToggle({ disabled = false }: { disabled?: boolean }) {
  const { ticket, setTicket } = useTicketSize();

  return (
    <div
      className="flex items-center gap-3"
      title={disabled ? "Ticket size doesn't apply to this page's data" : undefined}
    >
      <span className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
        Ticket Size
      </span>
      <ToggleGroup
        type="single"
        value={disabled ? "" : (ticket ?? "")}
        onValueChange={(value) => setTicket(value ? (value as TicketSize) : undefined)}
        disabled={disabled}
        className="border border-border bg-secondary"
        aria-label="Ticket size"
      >
        {TICKET_SIZE_OPTIONS.map((option) => (
          <ToggleGroupItem
            key={option.value}
            value={option.value}
            title={option.range}
            className="h-8 px-3 text-xs"
          >
            {option.label}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </div>
  );
}
